module.exports = __webpack_public_path__ + "img/6.c399bee4.png";